<template>
  <teleport to="body">
    <div
      v-if="open"
      class="mobile-sheet-scrim"
      @click.self="$emit('close')"
    ></div>
    <transition name="mobile-sheet">
      <div
        v-if="open"
        ref="sheet"
        class="mobile-sheet"
        role="dialog"
        aria-modal="true"
        :aria-label="label"
        tabindex="-1"
      >
        <div class="mobile-sheet__grab"></div>
        <slot></slot>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: "MobileActionsSheet",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Actions",
    },
  },
  emits: ["close"],
  data() {
    return {
      restoreFocusTo: null,
    };
  },
  watch: {
    open(isOpen) {
      // Scroll-lock the page behind the sheet.
      document.body.classList.toggle("mobile-sheet-open", isOpen);
      if (isOpen) {
        this.restoreFocusTo = document.activeElement;
        this.$nextTick(() => this.$refs.sheet?.focus());
      } else {
        this.restoreFocusTo?.focus?.();
        this.restoreFocusTo = null;
      }
    },
  },
  mounted() {
    this.onKeydown = (e) => {
      if (!this.open) return;
      if (e.key === "Escape") {
        this.$emit("close");
        return;
      }
      // Minimal focus trap: keep Tab cycling within the sheet.
      if (e.key === "Tab" && this.$refs.sheet) {
        const focusables = this.$refs.sheet.querySelectorAll(
          'button, a[href], input, [tabindex]:not([tabindex="-1"])',
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (e.shiftKey && (active === first || active === this.$refs.sheet)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        } else if (!this.$refs.sheet.contains(active)) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
    document.body.classList.remove("mobile-sheet-open");
  },
};
</script>
